<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div v-if="showPage" class="auth-inner py-2">

      <!-- Login v1 -->
      <b-card class="mb-0 mt-0">
        <b-link v-if="!isMobile()" class="items-center">
          <vuexy-logo />
        </b-link>

        <b-link v-if="isMobile()" class="items-center" style="display: block; justify-content: center; justify-items: center; align-items: center; text-align: center; align-content: center;">
          <img src="@/assets/images/logo/logo2.png" style="max-height: 15px;">
        </b-link>

        <!-- form -->
        <validation-observer
          ref="loginForm"
          #default="{invalid}"
        >
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent
          >

            <!-- email:
              admin: admin@demo.com
              client: client@demo.com
            -->
            
            <b-form-group
              label-for="email"
              label="Email"
            >
              <validation-provider
                #default="{ errors }"
                name="Email"
                rules="required|email"
              >
                <b-form-input
                  id="email"
                  v-model="userEmail"
                  name="login-email"
                  :state="errors.length > 0 ? false:null"
                  placeholder="john@example.com"
                  autofocus
                />
                <!--
                <small class="text-danger">{{ errors[0] }}</small>
                -->
              </validation-provider>
            </b-form-group>
          

            <!-- password 
              admin: admin
              client: client
            -->
            <b-form-group>
              <div class="d-flex justify-content-between">
                <label for="password">Password</label>
                <!--
                <b-link :to="{name:'auth-forgot-password-v1'}">
                  <small>Forgot Password?</small>
                </b-link>
                -->
              </div>
              <validation-provider
                #default="{ errors }"
                name="Password"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid':null"
                >
                  <b-form-input
                    id="password"
                    v-model="password"
                    :type="passwordFieldType"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false:null"
                    name="login-password"
                    placeholder="Password"
                  />

                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <!--
                <small class="text-danger">{{ errors[0] }}</small>
                -->
              </validation-provider>
            </b-form-group>
          

            <!-- checkbox -->
            <!--
            <b-form-group>
              <b-form-checkbox
                id="remember-me"
                v-model="status"
                name="checkbox-1"
              >
                Remember Me
              </b-form-checkbox>
            </b-form-group>
            -->

            <!-- submit button -->
            <p style="color: red">{{ displayErrors }}</p>

            <b-button
              @click="logIn()"
              variant="primary"
              type="submit"
              block
              :disabled="invalid"
            >
              Sign in
            </b-button>
          </b-form>
        </validation-observer>
        <!--
        <b-card-text class="text-center mt-2">
          <span>New on our platform? </span>
          <b-link :to="{name:'auth-register-v1'}">
            <span>Create an account</span>
          </b-link>
        </b-card-text>
        -->

        <!--
        <div class="divider my-2">
          <div class="divider-text">
            or
          </div>
        </div>
        -->

        <!-- social button -->

        <!--
        <div class="auth-footer-btn d-flex justify-content-center">
          <b-button
            href="javascript:void(0)"
            variant="facebook"
          >
            <feather-icon icon="FacebookIcon" />
          </b-button>
          <b-button
            href="javascript:void(0)"
            variant="twitter"
          >
            <feather-icon icon="TwitterIcon" />
          </b-button>
          <b-button
            href="javascript:void(0)"
            variant="google"
          >
            <feather-icon icon="MailIcon" />
          </b-button>
          <b-button
            href="javascript:void(0)"
            variant="github"
          >
            <feather-icon icon="GithubIcon" />
          </b-button>
        </div>
        -->

      </b-card>
      <!-- /Login v1 -->
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BButton, BForm, BFormInput, BFormGroup, BCard, BLink, BCardTitle, BCardText, BInputGroup, BInputGroupAppend, BFormCheckbox,
} from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import { getUserData } from '@/auth/utils'
import axios from 'axios'

export default {
  components: {
    // BSV
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BCardTitle,
    BLink,
    VuexyLogo,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      userEmail: '',
      password: '',
      status: '',
      // validation rules
      required,
      email: '',
      users: [],
      showPage: false,
      userData : [],
      displayErrors: null,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    isMobile() {
       if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
         return true
       } else {
         return false
       }
     },
    logIn() {
      //console.log('logging in')
      //if(this.userEmail == 'client@demo.com' && this.password == 'client') {
        
      let error = {
        email: ['Something went wrong'],
      }

      var url = 'https://flexoapi.online/api/users_get.php?login_email=' + this.userEmail + '&password=' + this.password

      //console.log('url: ' + url)
      axios
      .get(url)
      .then(response => (this.setUserData(response.data)))
      .catch(error => (this.setError('Email and Password combination not found')))
      .finally(function () {

      })

      //}
    },
    setUserData(userData) {
      //console.log('user data: ' + JSON.stringify(userData))

      //let user = this.users.find(u => u.email === this.userEmail && u.password === this.password)

      //if (user) {
      if (userData.fullName) {
        localStorage.setItem('userData', JSON.stringify(userData))

        //delete userData.password

        const response = {
          userData,
        }

        location.reload()
        return [200, response]
      } else {
        error = 'Email or Password is Invalid'
      }

      this.errors = error
      return [400, { error }]
    },
    setError(error) {
      console.log('error: ' + error)
      this.displayErrors = error
    }
    /*
    getUsers() {
      

      {
          id: 1,
          fullName: 'John Doe',
          username: 'johndoe',
          password: 'admin',
          // eslint-disable-next-line global-require
          avatar: require('@/assets/images/avatars/13-small.png'),
          email: 'admin@demo.com',
          role: 'admin',
          ability: [
            {
              action: 'manage',
              subject: 'all',
            },
          ],
          extras: {
            eCommerceCartItemsCount: 5,
          },
        },
        {
          id: 2,
          fullName: 'Jane Doe',
          username: 'janedoe',
          password: 'client',
          // eslint-disable-next-line global-require
          avatar: require('@/assets/images/avatars/1-small.png'),
          email: 'client@demo.com',
          role: 'client',
          ability: [
            {
              action: 'read',
              subject: 'ACL',
            },
            {
              action: 'read',
              subject: 'Auth',
            },
          ],
          extras: {
            eCommerceCartItemsCount: 5,
          },
        },
    }
    */
  },
  mounted() {
    const userData = JSON.parse(getUserData())
    if(userData) {
      this.$router.push('/dashboard')
    }
    else {
      this.showPage = true
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
